import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, InputAdornment, InputBase, Paper, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import { getTarea, postComentarioTarea, postComentarioTareaInter } from '../../../services/apis';
import { useNavigate, useParams } from 'react-router-dom';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import logoempresa from '../../../media/logoempresa.png';
import { RegistroAccionesCard } from '../../../utils/componentes-utiles/RegistroAccionesCard';
import { BarrasHorasSemanaEmpleado } from '../../../utils/componentes-utiles/graficas/BarrasHorasSemanaEmpleado';
import { BarrasHorasInvertidasTarea } from '../../../utils/componentes-utiles/graficas/BarrasHorasInvertidasTarea';
import { ChatInterno } from './ChatInterno';
import { convertirEnlaces } from '../../../utils/utils';


export const TareaDialog = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor, setHorasTotales }) => {

    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
    };
    const [tarea, setTarea] = useState(tareaInfo);

    //aux
    const mensajePorDefecto = [{
        autor: "3",
        color: "7303fc",
        comentario: "Escribe un Comentario",
    }];
    //utils
    const [comentarios, setComentarios] = useState([]);
    const [comentariosInternos, setComentariosInternos] = useState([]);
    const [mensaje, setMensaje] = useState('');
    const [mensajeInterno, setMensajeInterno] = useState('');
    const [tareaAcciones, setTareaAcciones] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [datoshoras, setDatosHoras] = useState([
        {
            "dia": "M1/7",
            "tareas": [
                {
                    "usuario": "Jorge Sanchez",
                    "id": 43,

                    "horas": 0.5
                },
                {
                    "usuario": "Jorge Sanchez",
                    "id": 32,

                    "horas": 1.75
                }
            ]
        },
        {
            "dia": "X2/7",
            "tareas": [
                {
                    "usuario": "Jorge Sanchez",
                    "id": 433,

                    "horas": 0.5
                },
                {
                    "usuario": "Cristian Garcia",
                    "id": 53,

                    "horas": 3.5
                }
            ]
        },
        {
            "dia": "V4/7",
            "tareas": [
                {
                    "usuario": "Jorge Sanchez",
                    "id": 3,
                    "horas": 0.25
                },
                {
                    "usuario": "Ivan Aguilar",
                    "id": 2,
                    "horas": 2.5
                },
                {
                    "usuario": "Jorge Sanchez",
                    "id": 1,
                    "horas": 2
                }
            ]
        },

    ]);
    const [chats, setChats] = useState([])

    const param = useParams();



    const handleInputChange = (event) => {
        setMensaje(event.target.value);
    };
    const handleInputChangeInterno = (event) => {
        setMensajeInterno(event.target.value);
    };

    const handleKeyPress = (event) => {
        console.log(event.target.name);

        if (event.target.name === 'mensaje') {
            if (event.key === 'Enter') {
                event.preventDefault();
                enviarComentario();
            }
        } else {
            if (event.key === 'Enter') {
                event.preventDefault();
                enviarComentarioInterno();
            }
        }
    };


    const cargarTareas = async () => {
        try {
            const response = await getTarea(tarea.id_proyecto, tarea.id, 2);
            setComentarios(response.data.comentarios.length > 0 ? response.data.comentarios : mensajePorDefecto);
            setComentariosInternos(response.data.comentarios_internos.length > 0 ? response.data.comentarios_internos : mensajePorDefecto);
            setTareaAcciones(response.data.acciones);
            setDatosHoras(response.data.tareas_agrupadas ? response.data.tareas_agrupadas : []);
            setChats(response.data.chats)
            // setOpciones(response.data.opcionesTareas);
        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }
    }



    const enviarComentario = async () => {

        if (mensaje != '') {
            let temp = [...comentarios];
            let nuevoComentario = {
                autor: "1",
                color: '#FFFFFFF',
                comentario: mensaje,
                fecha: "2024-06-10",
                nombre: localStorage.username,
                id_tarea: tarea.id,
                id_proyecto: tarea.id_proyecto
            }
            try {
                const response = await postComentarioTarea(nuevoComentario);


            } catch (error) {
                console.error("Error al añadir el cliente:", error);
            }

            temp.push(nuevoComentario);
            setMensaje('')
            cargarTareas()
        }

    }

    const enviarComentarioInterno = async () => {

        if (mensajeInterno != '') {
            let temp = [...comentarios];
            let nuevoComentario = {
                autor: "1",
                color: '#FFFFFFF',
                comentario: mensajeInterno,
                fecha: "2024-06-10",
                nombre: localStorage.username,
                id_tarea: tarea.id,
                id_proyecto: tarea.id_proyecto
            }
            try {
                const response = await postComentarioTareaInter(nuevoComentario);


            } catch (error) {
                console.error("Error al añadir el cliente:", error);
            }

            temp.push(nuevoComentario);
            setMensajeInterno('')
            cargarTareas()
        }

    }

    useEffect(() => {
        if (open === true) {
            cargarTareas();
        }
    }, [open])


    const calcularTotalHorasFormateado = (diasEditados) => {
        const totalDecimal = diasEditados.reduce((total, dia) => {
            return total + dia.tareas.reduce((sum, tarea) => sum + (tarea.horas || 0), 0);
        }, 0);

        const horas = Math.floor(totalDecimal);
        const minutos = Math.round((totalDecimal - horas) * 60);

        setHorasTotales(`${horas}h${minutos > 0 ? ` ${minutos}min` : ''}`)
        return `${horas}h${minutos > 0 ? ` ${minutos}min` : ''}`;
    };
    const opcionesChats = {
        ChatInterno: <ChatInterno
            comentariosInternos={comentariosInternos}
            enviarComentario={enviarComentario}
            mensajeInterno={mensajeInterno}
            handleInputChangeInterno={handleInputChangeInterno}
            handleKeyPress={handleKeyPress}
            enviarComentarioInterno={enviarComentarioInterno}
        >
        </ChatInterno>,
    }
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth='xl'
        >

            <DialogContent style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor,
                minWidth: '90%'
            }}>
                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems="start"
                    xs={12}
                    sx={{ mb: 3 }}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        sx={{ mb: 3 }}
                    >
                        <Grid
                            container
                            xs={8}
                            justifyContent="start"
                            alignItems="start"
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2, // Limita el número de líneas
                                WebkitBoxOrient: 'vertical',
                                minHeight: '4vh', // Ajusta este valor a la altura fija que deseas
                                maxHeight: '10vh',
                            }}
                        >
                            <Typography variant='h5'>
                                {tareaInfo.id}
                            </Typography>

                            <Typography variant='h4'>
                                {tarea.asunto}
                            </Typography>
                        </Grid>

                        <CancelIcon variant='contained' className='pointer' onClick={handleClose}></CancelIcon>
                    </Grid>

                    <Typography variant='subtitle1'>
                        <strong> Cliente: </strong> {tarea.cliente}
                    </Typography>

                    <Typography variant="subtitle1">
                        <strong>Correo: </strong>{tareaInfo.correo}
                    </Typography>

                    <Typography variant='h5'>
                        <strong> Descripción:</strong> {tarea.descripcion}
                    </Typography>
                    <Grid container xs={12} >
                        <BarrasHorasInvertidasTarea data={datoshoras} id_tarea={tareaInfo.id} cargarTareas={cargarTareas}></BarrasHorasInvertidasTarea>

                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        sx={{ mt: 2 }}
                    >
                        <Grid item xs={12} style={{ textAlign: 'left' }}>
                            <Typography variant="subtitle1">
                                {/* <strong> Horas empleadas: </strong>
                                {`${Math.floor(tareaInfo.minutos / 60)}h ${tareaInfo.minutos % 60}m`}<br></br> */}
                                <strong> Horas empleadas: </strong>

                                {calcularTotalHorasFormateado(datoshoras)}
                            </Typography>
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="start"
                            xs={12} md={3.5}
                        >
                            {tareaInfo.trabajadores.length > 0 && (
                                <Grid container xs={12} direction="row" justifyContent="start" alignItems="start">
                                    <Grid container xs={12} direction="row" justifyContent="start" alignItems="start" >
                                        <Typography variant="subtitle1" gutterBottom>
                                            <strong> Asignado a:&nbsp;</strong>
                                            {(tareaInfo.trabajadores.slice(0, 3)).map((trabajador, index) => (
                                                <span>{trabajador.label}&nbsp;</span>
                                                // <Grid item xs={12} textAlign={'left'}>
                                                //     <Typography variant="caption" gutterBottom key={index} sx={{ fontWeight: 600 }}>
                                                //         {trabajador.label}&nbsp;
                                                //     </Typography>
                                                // </Grid>
                                            ))}
                                        </Typography>
                                    </Grid>


                                    <>
                                        {tareaInfo.trabajadores.length > 3 && (
                                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                                                y mas...
                                            </Typography>
                                        )}
                                    </>
                                </Grid>
                            )}
                            {tareaInfo.trabajadores.length == 0 && (
                                <Grid container xs={12} justifyContent="start" alignItems="center">
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Asignado a: </strong>Sin Asignar
                                    </Typography>
                                </Grid>
                            )}


                        </Grid>


                        <Grid
                            container
                            direction="row"
                            justifyContent="end"
                            alignItems="start"
                            xs={12} lg={3.5}
                        // style={{
                        // minHeight: '15vh',
                        // maxHeight: '35vh',
                        // }}
                        >
                            {tareaInfo.usuarios_con_tiempo.length > 0 && (
                                <Grid container xs={12} justifyContent="end" alignItems="start">
                                    <Typography variant="subtitle1" gutterBottom style={{ marginBottom: '-0.2em' }} >
                                        <strong>En curso por:&nbsp;</strong>
                                        {(tareaInfo.usuarios_con_tiempo.slice(0, 3)).map((trabajador, index) => (
                                            <span>{trabajador.label}&nbsp;</span>
                                        ))}
                                    </Typography>

                                    <>
                                        {tareaInfo.usuarios_con_tiempo.length > 3 && (
                                            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                                                y mas...
                                            </Typography>
                                        )}
                                    </>
                                </Grid>
                            )}
                            {tareaInfo.usuarios_con_tiempo.length == 0 && (
                                <Grid container xs={12} justifyContent="end" alignItems="end" >
                                    <Typography variant="subtitle1" gutterBottom textAlign={'right'}>
                                        <strong>En curso por: </strong>Sin Trabajadores En Curso
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom textAlign={'right'}>

                                    </Typography>
                                </Grid>
                            )}

                        </Grid>
                    </Grid>

                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="start"
                    xs={12}
                >
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        xs={12} lg={3.75}
                    >
                        {comentarios.length > 0 && (
                            <>
                                <div className='envase-chat'>
                                    <strong>&nbsp;Comentarios:</strong>
                                    <div className='contenedor-chat' style={{ minHeight: '25.5vh', maxHeight: '25.5vh', overflow: 'auto' }}>
                                        {comentarios.map((comentario => (

                                            <Grid
                                                container
                                                direction="column"
                                                justifyContent="center"
                                                alignItems="center"
                                                xs={10}
                                                className={`bocadillo-chat ${comentario.autor == 1 ? 'autor' : ''}`}
                                                key={comentario.id}
                                            >
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="start"
                                                    alignItems="start"
                                                    xs={12}
                                                >
                                                    <Typography variant='subtitle1' sx={{ color: comentario.color, textAlign: 'left' }} >
                                                        <strong>{comentario.nombre}</strong>
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="start"
                                                    alignItems="start"
                                                    xs={12}
                                                >
                                                    <Typography variant='body2' className='texto-con-salto'>
                                                        {convertirEnlaces(comentario.comentario)}
                                                    </Typography>
                                                </Grid>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="end"
                                                    alignItems="end"
                                                    xs={12}
                                                >
                                                    <Typography variant='caption'>
                                                        <strong>{comentario.fecha}</strong>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        )))}

                                    </div>
                                    <Grid xs={12} className='chat-bar'>
                                        <Paper
                                            component="form"
                                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#e1e0e0' }}
                                            variant='outlined'
                                            onSubmit={(e) => { e.preventDefault(); enviarComentario(); }}
                                        >
                                            <InputBase
                                                sx={{ ml: 1, flex: 1 }}
                                                placeholder="Escribe un mensaje nuevo"
                                                inputProps={{ 'aria-label': 'Escribe un mensaje nuevo' }}
                                                value={mensaje}
                                                name='mensaje'
                                                onChange={handleInputChange}
                                                onKeyPress={handleKeyPress}
                                            />
                                            <IconButton type="button" sx={{ p: '10px' }} aria-label="send" >
                                                <SendIcon onClick={() => enviarComentario()} />
                                            </IconButton>
                                        </Paper>
                                    </Grid>
                                </div>
                            </>
                        )}


                    </Grid>

                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        xs={12} lg={3.75}
                    >
                        {/* // comentarios internos */}
                        {chats[0] && (
                            <>
                                {opcionesChats[chats[0].nombre]}
                            </>
                        )}
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        xs={12} lg={4}
                    >
                        <RegistroAccionesCard acciones={tareaAcciones} />
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="end"
                        alignItems="center"
                        xs={12}
                    >
                        <Typography variant='inherit'>
                            <strong>Creado por: </strong>{tareaInfo.creador}
                        </Typography>
                    </Grid>

                </Grid>







            </DialogContent>
            {/* <DialogActions style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                {opciones.map((opcion, index) => (
                    <Grid container xs={3} sm={3} md={3} xl={3} gap={1} justifyContent="space-around" alignItems="center">
                        <Button
                            variant='contained'
                            className='button-default'
                            key={index}
                            onClick={() => handleEvent(opcion.id_estado)}
                            disabled={
                                opcion.id_estado == 4 ? tarea.id_estado != 3 :
                                tarea.id_estado == 3 && opcion.id_estado != 4
                                        ? true
                                        : (tarea.id_estado == 1)
                                            ? (opcion.id_estado == 1)
                                            : (opcion.id_estado == 2)}
                        >
                            {opcion.nombre}
                        </Button>
                    </Grid>

                ))}
            </DialogActions> */}
        </Dialog>
    )
}
